module.exports = __webpack_public_path__ + "img/ico-img-active.fc388b3a.png";